<mat-card appearance="outlined" class="mt-4">
    <mat-card-header>
        <mat-card-title>{{ item.name }}</mat-card-title>
        <div>
            <button mat-icon-button
                    [matMenuTriggerFor]="itemMenu">
                    <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #itemMenu="matMenu">
              <button mat-menu-item (click)="onEdit()">
                <mat-icon>settings</mat-icon>
                <span i18n>Edit state</span>
              </button>
            </mat-menu>
        </div>
    </mat-card-header>
    <mat-card-content class="pt-3">
      <ng-container *ngIf="hasCanDeleteBookingPermissions()">
      <h3 i18n>Booking can be deleted in this state by following roles</h3>
      <p>{{ canDeleteRolesDescription() }}</p>
      </ng-container>
    </mat-card-content>
</mat-card>
